/**
 * ApprovalShell — shell layout cho các trang Phê duyệt.
 * Sidebar trái được host ở global secondary slot (ApprovalsSecondaryNav) — Shell chỉ render main.
 * Children prop ưu tiên (cho usage cũ); ngược lại dùng Outlet (cho nested routes).
 */
import { Outlet } from 'react-router-dom';

export default function ApprovalShell({ children }) {
  return (
    <div className="flex h-full bg-slate-50">
      <main className="flex-1 flex flex-col min-w-0">
        {children || <Outlet />}
      </main>
    </div>
  );
}
